"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BlurBackground = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_BlurBackground_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 2h.674L0 5.874V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 2 2.08 2 3.2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.811 2 0 8.811V10.8c0 .37 0 .678.008.941l4.86-4.86c.02.805.344 1.534.86 2.077l-.6.6a4.784 4.784 0 0 0-.555.295c-.652.405-1.188.981-1.431 1.692l-2.17 2.17c.039.024.079.046.12.067C1.52 14 2.08 14 3.2 14h2.392A1.598 1.598 0 0 1 4 12.4c0-1.253 1.43-2.282 3.615-2.39.126-.007.254-.01.385-.01.844 0 1.589.133 2.2.363.46.173.844.4 1.138.668.212.194.378.408.49.638.113.23.172.476.172.731a1.6 1.6 0 0 1-1.592 1.6H12.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 12.48 16 11.92 16 10.8v-.366l-3.502 3.502c.316-.43.502-.961.502-1.536a2.68 2.68 0 0 0-.44-1.464L16 7.496V5.2c0-.235 0-.446-.002-.636L10.962 9.6a5.733 5.733 0 0 0-.997-.36 3.127 3.127 0 0 0 1.155-2.735l4.094-4.094a2.003 2.003 0 0 0-.306-.193C14.48 2 13.92 2 12.8 2h-.113l-2.529 2.529a3.122 3.122 0 0 0-2.076-.861L9.749 2H6.811Zm3.132 5.682A2.141 2.141 0 0 1 8 8.933a2.128 2.128 0 0 1-1.564-.682 2.133 2.133 0 1 1 3.507-.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_BlurBackground_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = BlurBackground;
exports["default"] = _default;